
export const SPRITE_PATHS = {
  "default": "/_nuxt/nuxt-svg/sprite-default.3ftimiYldHYI0RCZ5WKFmxY5LddTgzLbH20LlFq4DGc.svg"
}
export const runtimeOptions = {"ariaHidden":false}
